import React, { ComponentProps } from "react";

export default function TagIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M2.16683 9.66699L9.66683 2.16699C9.9585 1.83366 10.3752 1.66699 10.8335 1.66699H16.6668C17.5835 1.66699 18.3335 2.41699 18.3335 3.33366V9.16699C18.3335 9.62533 18.1668 10.042 17.8335 10.3337L10.3335 17.8337C10.0418 18.1253 9.62516 18.3337 9.16683 18.3337C8.7085 18.3337 8.29183 18.1253 8.00016 17.8337L2.16683 12.0003C1.87516 11.7087 1.66683 11.292 1.66683 10.8337C1.66683 10.3753 1.87516 9.95866 2.16683 9.66699ZM15.4168 5.83366C16.1252 5.83366 16.6668 5.29199 16.6668 4.58366C16.6668 3.87533 16.1252 3.33366 15.4168 3.33366C14.7085 3.33366 14.1668 3.87533 14.1668 4.58366C14.1668 5.29199 14.7085 5.83366 15.4168 5.83366Z"
        fill="#D9D9D9"
      />
    </svg>
  );
}
